
// export default service
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { oauthLogin } from '@/utils/oauth'
import qs from 'qs'
import moment from "moment"

let unauthorizedFlag = false

// create an axios instance
const service = axios.create({
  baseURL: '/API', // api的base_url
  timeout: 600000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
  if (window.localStorage.getItem("token")) {
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers['Authorization'] = 'Bearer ' + window.localStorage.getItem("token")
  }
  if (config.method === 'get') {
    config.url = `${config.url}?` + `${qs.stringify(config.data)}`
    config.paramsSerializer = (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    if (response.config.responseType === 'blob') {
      if (response.config.headers.blobType == 'import') { // blobType == 'import' 为导入数据，需求单独处理，则return response
        return response
      } else {
        if (response.data.type === 'application/json') {
          Message({
            message: '目前暂无数据可导出',
            type: 'error',
            duration: 3 * 1000
          })
        } else {
          if (res.size === 0) {
            Message({
              message: '目前暂无数据可导出',
              type: 'error',
              duration: 3 * 1000
            })
            return null
          }
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          let link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          let today = moment().format('YYMMDDHHmmss')
          link.download = response.config.data ? `${JSON.parse(response.config.data).fileName || '导出Excel'}${today}` : `${response.config.params.fileName || '导出Excel'}${today}`
          link.click()
          link = null
          return res
        }
        return null
      }
    }
    if (res.code !== 200) {
      console.log('response.config.url:', response.config.url);
      if (res.code === 401) {
        if (!unauthorizedFlag) {
          MessageBox.alert('登陆超时，请重新登录', '登录超时', {
            confirmButtonText: '重新登录',
            showClose: false,
            type: 'warning'
          }).then(() => {
            oauthLogin()
          })
          unauthorizedFlag = true
        }
      } else if (response.data.type === 'text/xml') {
        return response.data
      } else if (res.code === 206 && response.config.url === '/API/qs/question/del') {
        return res;
      } else if (res.code === 0 && response.config.url === '/API/newMall/couponv2/sc/user-file/upload/excel') {
        return res;
      } else if (res.code === 205 && (response.config.url === '/API/newMall/activityFloor/createActivityFloor' || response.config.url === '/API/newMall/activityFloor/updateActivityFloor')) {
        return res;
      } else if (res.code === 202 && response.config.url === '/API/newMall/tag/create') {
        return res;
      } else {
        Message({
          message: res.mes,
          type: 'error',
          duration: 3 * 1000
        })
        return Promise.reject('error')
      }
    } else {
      return response.data
    }
  },
  error => {
    console.log('err', error) // for debug
    if(error == 'Error: Network Error'){
      Message({
        message: '暂无网络',
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(error)
    }
    if (error.response) {
      if (error.response.status === 401) {
        if (!unauthorizedFlag) {
          MessageBox.alert('登陆超时，请重新登录', '登录超时', {
            confirmButtonText: '重新登录',
            showClose: false,
            type: 'warning'
          }).then(() => {
            oauthLogin()
          })
          unauthorizedFlag = true
        }
      } else {
        Message({
          message: `请求服务端出错${error.mes?error.mes:error.message}`,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(error)
    }
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js